import React, { useState } from "react";

import { Alert, TextField, Typography } from "@mui/material";

import ConfirmDialog from "components/shared/confirm-dialog";

interface TransferDocumentsDialogProps {
  open: boolean;
  setOpen: (newOpen: boolean) => void;
  transferDocuments: (toID: string) => void;
  isInspection: boolean;
  numDocuments: number;
}
const TransferDocumentsDialog = ({
  open,
  setOpen,
  transferDocuments,
  isInspection,
  numDocuments,
}: TransferDocumentsDialogProps) => {
  const [userID, setUserID] = useState("");

  const isInvalidInput = userID !== "" && !userID.startsWith("user_");

  return (
    <ConfirmDialog
      title={`Transfer User ${isInspection ? "Inspections" : "Templates"}`}
      open={open}
      setOpen={setOpen}
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Transfer"
      onConfirm={() => transferDocuments(userID)}
      disabled={isInvalidInput || userID === ""}
    >
      <Alert
        severity="info"
        variant="outlined"
        style={{ marginBottom: "1rem" }}
      >
        <div>
          <div style={{ marginBottom: "8px" }}>
            Transferring {isInspection ? "inspections" : "templates"} will
            change their ownership to the user specified below. This feature
            only supports target users within the same data centre.{" "}
            {!isInspection &&
              "It is recommended to use the private library or external sharing of templates to send a copy to a user in a different data centre."}
          </div>
          <div>
            <b>Important:</b> When {isInspection ? "inspections" : "templates"}{" "}
            are transferred to a user in a different organisation, all access
            rules are automatically reset to only include the new document
            owner. You will need to manually reconfigure sharing permissions and
            access rules after the transfer is complete.
          </div>
        </div>
      </Alert>
      <Alert
        severity="warning"
        variant="filled"
        style={{ marginBottom: "1rem" }}
      >
        Contact #business-systems slack channel if the{" "}
        {isInspection ? "inspection" : "template"}
        {numDocuments !== 1 ? "s" : ""} contain
        <b> GRS {isInspection ? "and/or sites" : ""} </b> and will be
        transferred to a <b>different organisation</b>, because{" "}
        <b>they will be broken</b> after the transfer.
      </Alert>
      <Typography marginTop="1rem">
        Enter the user ID of the user to transfer {numDocuments}{" "}
        {isInspection ? "inspection" : "template"}
        {numDocuments !== 1 ? "s" : ""} to.
      </Typography>

      <TextField
        margin="normal"
        label="User ID"
        variant="outlined"
        size="small"
        style={{ width: "100%" }}
        value={userID}
        onChange={(e) => setUserID(e.target.value)}
        helperText={isInvalidInput ? "Invalid user ID" : ""}
        error={isInvalidInput}
        inputProps={{
          "data-testid": "transfer-document-to-user-field",
        }}
      />
    </ConfirmDialog>
  );
};
export default TransferDocumentsDialog;
